import { EventBus, Events } from "jiffy-store";
import { parameterizeColor } from "common/utils/enhanced-url-generator";

const updateReviewsLinkColor = newColor => {
  if (!newColor) return;

  const $reviewsLink = document.querySelector(".js-reviews-see-all-link");

  if (!$reviewsLink) return;

  let currentUrl;
  try {
    currentUrl = new URL($reviewsLink.href);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("Invalid reviews link URL:", error);
    return;
  }

  // Update the made_color parameter with normalized color name
  if (currentUrl.searchParams.has("made_color")) {
    const normalizedColor = parameterizeColor(newColor);
    currentUrl.searchParams.set("made_color", normalizedColor);
    $reviewsLink.href = currentUrl.toString();
  }
};

let listenersInitialized = false;

const initColorChangeListener = () => {
  if (listenersInitialized) return;
  listenersInitialized = true;

  // Listen for color changes from both slider and modal
  EventBus.on(Events.PRODUCT_COLOR_SELECTED_FROM_SLIDER, (evt, { color }) => {
    updateReviewsLinkColor(color);
  });

  EventBus.on(Events.PRODUCT_COLOR_SELECTED, (evt, { color }) => {
    updateReviewsLinkColor(color);
  });
};

export default () => {
  initColorChangeListener();
};
